import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-no-entries-placeholder',
  templateUrl: './no-entries-placeholder.component.html',
})
export class NoEntriesPlaceholderComponent {
  public text: InputSignal<string> = input('Keine Einträge verfügbar');
}
